import { render } from "./SelectInput.vue?vue&type=template&id=1952dd64&scoped=true"
import script from "./SelectInput.vue?vue&type=script&lang=js"
export * from "./SelectInput.vue?vue&type=script&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=1952dd64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1952dd64"]])

export default __exports__